import Image, { StaticImageData } from 'next/legacy/image';
import Link from 'next/link';

import { H4 } from '@common/headline';
import { BodyRegular } from '@common/body';

type Props = {
  image: StaticImageData | string;
  altText: string;
  title: string;
  subtitle?: string;
  supertitle?: string;
  href?: string;
};

export const ImageCard = ({
  image,
  altText,
  title,
  subtitle,
  supertitle,
  href,
}: Props): JSX.Element => {
  const inner = (
    <div className="flex h-[447px] w-[351px] flex-col overflow-hidden rounded-3xl">
      <div className="h-[263px] w-[351px]">
        <Image
          src={image}
          alt={altText}
          layout="fixed"
          width={351}
          height={263}
          objectFit="cover"
          objectPosition="center center"
        />
      </div>
      <div className="flex flex-1 flex-col rounded-b-3xl bg-mono-white p-6">
        {supertitle && (
          <div className="mb-2 text-blue-600">
            <BodyRegular>{supertitle}</BodyRegular>
          </div>
        )}
        <div className="line-clamp-2 h-[60px]">
          <H4>{title}</H4>
        </div>
        {subtitle && (
          <div className="mt-2 line-clamp-4 text-blue-800">
            <BodyRegular>{subtitle}</BodyRegular>
          </div>
        )}
      </div>
    </div>
  );

  if (!href) {
    return inner;
  }

  return (
    <Link href={href}>
      <div className="cursor-pointer">{inner}</div>
    </Link>
  );
};

export const ImageCardLarge = ({
  image,
  altText,
  title,
  subtitle,
  supertitle,
  href,
}: Props): JSX.Element => {
  const inner = (
    <div className="flex w-[760px] flex-col overflow-hidden rounded-3xl">
      <Image
        src={image}
        alt={altText}
        layout="fixed"
        width={760}
        height={395}
        objectFit="cover"
        objectPosition="center center"
      />
      <div className="h-[160px] rounded-b-3xl bg-mono-white p-6">
        {supertitle && (
          <div className="mb-2 text-blue-600">
            <BodyRegular>{supertitle}</BodyRegular>
          </div>
        )}
        <H4>{title}</H4>
        {subtitle && (
          <div className="mt-2 text-blue-800">
            <BodyRegular>{subtitle}</BodyRegular>
          </div>
        )}
      </div>
    </div>
  );

  if (!href) {
    return inner;
  }

  return (
    <Link href={href}>
      <div className="cursor-pointer">{inner}</div>
    </Link>
  );
};
